import {getRelativeWidth} from '../../config';
import {AnyJsx} from '../../assets/ts/customTypes';
import {LandingpageButtonContainer, LandingpageButtonText, LandingpageButtonArrow, LandingpageButtonLabelContainer, LandingpageButtonArrowLeft} from '../../assets/ts/components/landingpagebutton';
import ButtonArrow from '../../assets/icons/navi/overview-btn-arrow.svg';
import { FooterButtonBackground } from './FooterButtonBackground';

export function LandingpageButton(props: {
    width: number;
    onClick: () => void;
    children: AnyJsx;
    arrow?: 'left' | 'right' | undefined;
}) {
    return (
        <LandingpageButtonContainer onClick={props.onClick} width={getRelativeWidth(props.width)}>
            <FooterButtonBackground width={props.width} className='background' />

            <LandingpageButtonLabelContainer>
                {props.arrow === 'left' && <LandingpageButtonArrowLeft src={ButtonArrow} alt='' />}
                <LandingpageButtonText>{props.children}</LandingpageButtonText>
                {props.arrow !== 'left' && <LandingpageButtonArrow src={ButtonArrow} alt='' />}
            </LandingpageButtonLabelContainer>
        </LandingpageButtonContainer>
    );
}
